export const SUBSCRIPTIONS_SCHEMA = {
  en: {
    navigation: {
      segment_text: "Subscriptions",
    },
    table: {
      title: "Subscriptions",
      search_placeholder: "Search by Service",
      filter_title: "Filter Subscriptions",
      headers: {
        service: "Service",
        status: "Status",
        period: "Payment Period",
      },
      quick_filters: {
        all: "All",
        active: "Active",
        cancelled: "Cancelled",
      },
      fallback_service: "Subscription Plan",
      actions: {
        view_details: "View Details",
        unsubscribe: "Unsubscribe",
      },
      periods: {
        monthly: "Monthly payments",
        quarterly: "Quarterly payments",
        yearly: "Yearly payments",
      },
      statuses: {
        active: "Active",
        cancelled: "Cancelled",
        draft: "Draft",
      },
    },
    errors: {
      fetch_failed: "Failed to fetch subscription history",
      unable_to_load_title: "Unable to load subscriptions",
      general_fallback:
        "Failed to fetch subscription history. Please try again later.",
    },
    details: {
      title: "Subscription Details",
      next_payment: "Next Payment",
      last_payment: "Last Payment",
      amount_to_charge: "Amount to Charge",
      payment_method: "Payment Method",
      payment_cycle: "Cycle",

      // Invoice History Table Headers
      invoice_history_title: "Billing History",
      invoice_amount: "Amount Paid",
      invoice_status: "Status",
      invoice_date: "Date",
      no_invoices: "No billing history found.",
    },
    empty_state: {
      title: "No subscriptions yet",
      text: "Your subscription payment history will appear here once active.",
    },
  },
};
